import React from "react";
import { AlertTriangle } from "lucide-react";
import { Field, TextInput } from "@/components/FormKit";

/** Shown when creating a task/visit/opportunity on a SUPPRESSED organisation.
 * Requires an explicit override reason (logged to the audit trail server-side). */
export function OverrideNotice({ value, onChange, entity }) {
  return (
    <div className="rounded-lg border border-amber-300 bg-amber-50 p-3" data-testid="override-notice">
      <div className="flex items-start gap-2">
        <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0 text-amber-600" />
        <p className="text-xs text-amber-900">
          This organisation is <strong>suppressed</strong>. You can still add a {entity}, but you
          must give a reason — it will be recorded in the audit trail.
        </p>
      </div>
      <div className="mt-2">
        <Field label="Override reason">
          <TextInput testid="override-reason" value={value} onChange={(e) => onChange(e.target.value)} placeholder="Why is contact justified?" />
        </Field>
      </div>
    </div>
  );
}
